<!-- 企微用户绑定账号/角色ID -->
<template>
  <div
    class="container"
    :class="{
      bg_grey: !hasBind,
      bg_white: hasBind,
    }"
  >
    <template v-if="!hasBind">
      <div class="header">
        <div class="header_title mb_16">
          <p class="bold" style="text-indent: 0.8em;">完成<span class="bold">{{ isFromAPP ? '账号' : '角色' }}确认</span>可领惊喜</p>
        </div>
        <div class="header_main card_wrap">
          <div class="header_guide card_head bold">
            输入<span class="bold">{{ valueLabelStr }}</span>为您匹配角色信息:
          </div>
          <div class="header_oper card_main flex_center mt_12 mb_16">
            <div class="oper_label bold">{{ valueLabelStr }}:</div>
            <div class="oper_form" style="flex: 1; width: 0">
              <input
                type="text"
                :placeholder="`请输入登录游戏时的${valueLabelStr}`"
                v-model="inputValue"
                :disabled="roleQueryLoading || bindLoading"
              />
            </div>
            <div class="oper_btn">
              <van-button
                size="small"
                round
                color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
                style="padding: 0 28px;"
                :loading="roleQueryLoading"
                :disabled="roleQueryLoading || bindLoading"
                loading-text="查询中..."
                @click="onBinding"
              >
                <span class="bold">确认</span>
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isFromAPP" class="body">
        <div class="body_main card_wrap">
          <div class="card_head flex_a_c">
            <span class="mr_8 bold">如何获取{{ valueLabelStr }}？参考下方图示</span>
            <img class="down_img" src="https://image.hzwxbz2.cn/java-yunying/jyy_1728888374850_74e8333ad11685ff3bdae589c8f6e34d.png" alt="">
          </div>
          <div class="card_main">
            <img style="width: 100%" v-if="rolePic" :src="rolePic" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="bind_success fs_16 mt_40">
        <div class="d_flex_col flex_a_c mb_20">
          <img style="width: 54px;" class="mb_16" src="https://image.hzwxbz2.cn/java-yunying/jyy_1728892673462_6b2ded51d81a4403d8a4bd25fa1e57ee.png" />
          <p class="bold fs_18">
            已完成确认
          </p>
        </div>
        <div class="bind_info">
          <div class="bind_info_item flex_center">
            <div class="bind_info_label mr_12">
              {{ valueLabelStr }}:
            </div>
            <div class="bind_info_value w_0 flex_1" style="word-wrap: break-word; line-height: 1.24;">
              {{ account }}
            </div>
          </div>
        </div>
        <div class="bind_jump pl_12 pr_12">
          <van-button
            size="large"
            round
            color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
            @click="onJump"
          >
            参与活动
          </van-button>
        </div>
      </div>
    </template>
    <van-popup
      v-model="showRolePopup"
      round
      :closeable="!bindLoading"
      :close-on-click-overlay="!bindLoading"
      position="center"
      class="role_popup"
      @closed="clearRolePopupData"
    >
      <div class="role_popup_title bold">确认角色</div>
      <div class="role_popup_tip">匹配到以下角色信息：</div>
      <div class="role_list">
        <div
          v-for="role in roleList"
          :key="`${role.user_id}-${role.appkey}-${role.role_id}`"
          class="role_item"
          :class="{ active: isSelectedRole(role) }"
          @click="selectRole(role)"
        >
          <span>角色名：{{ role.role_name }}</span>
          <span>游戏：{{ role.game_name }}</span>
        </div>
      </div>
      <div class="role_popup_confirm bold">请选择角色并确认</div>
      <van-button
        class="role_confirm_btn"
        color="linear-gradient(61deg, #658dfd 0%, #565ade 100%)"
        :disabled="!selectedRole"
        :loading="bindLoading"
        @click="confirmSelectedRole"
      >确认</van-button>
    </van-popup>
  </div>
</template>

<script>
import { qwBinding, getQWBindingInfo, getQWRoleList } from '@/apis/gameJump'
import { Button, Popup, Toast } from 'vant';
import track from './components/track'

export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
  },
  mixins: [track],
  data () {
    return {
      inputValue: '',
      account: '', // 已绑定的角色或账号
      hasBind: false, // 是否已绑定
      bindLoading: false,
      roleQueryLoading: false,
      rolePic: '',
      jump_url: '',
      qy_weixin_user: '',
      showRolePopup: false,
      roleList: [],
      selectedRole: null,
      roleQueryRequestId: 0,
      bindRequestId: 0,
      roleQuerySlowTimer: null,
    }
  },
  created () {
    this.getBindInfo()
  },

  beforeDestroy () {
    this.roleQueryRequestId += 1
    this.bindRequestId += 1
    this.clearRoleQuerySlowTimer()
  },

  computed: {
    query () {
      return this.$route.query || {}
    },
    // 是否来自 app app 需要绑定账号、小游戏需要绑定角色
    isFromAPP () {
      return this.query.scene_type * 1 === 2
    },
    valueLabelStr () {
      return this.isFromAPP ? '账号' : '角色ID'
    },
  },
  methods: {
    getBindInfo (init = true) {
      getQWBindingInfo({
        id: this.query.id,
        gu: this.query.gu,
        external_userid: this.query.external_userid,
        scene_type: this.query.scene_type,
      }).then(res => {
        console.log(res)
        const {
          status, user_name, user_id, role_name, role_id,
          role_id_lead_image, jump_url, qy_weixin_user
        } = res.content
        this.rolePic = role_id_lead_image
        this.hasBind = status * 1 === 1
        this.jump_url = jump_url
        this.qy_weixin_user = qy_weixin_user
        if (this.hasBind) {
          document.title = '确认成功'
          this.account = this.isFromAPP ? user_id : role_id
        }
        if (init) {
          this.buryReport("QY_WEIXIN_GENERAL_BIND_SHOW", {
            qy_weixin_user: qy_weixin_user,
            type: this.isFromAPP ? 1 : 2,
            user_id: this.account,
          });
        }
      })
    },
    onBinding () {
      const inputValue = this.inputValue.trim()
      if (!inputValue) {
        this.$toast('请输入')
        return
      }
      if (this.bindLoading || this.roleQueryLoading) return
      if (this.isFromAPP) {
        this.performBinding({ user_name: inputValue })
        return
      }
      const requestId = ++this.roleQueryRequestId
      this.roleQueryLoading = true
      this.showRolePopup = false
      this.clearRolePopupData()
      this.clearRoleQuerySlowTimer()
      this.roleQuerySlowTimer = setTimeout(() => {
        if (requestId === this.roleQueryRequestId && this.roleQueryLoading) {
          this.$toast('查询时间较长，请耐心等待')
        }
      }, 5000)
      getQWRoleList({
        id: this.query.id,
        gu: this.query.gu,
        external_userid: this.query.external_userid,
        scene_type: this.query.scene_type,
        role_id: inputValue,
      }).then(res => {
        if (requestId !== this.roleQueryRequestId) return
        const roles = (res.content && res.content.role_list) || []
        if (!roles.length) {
          this.$toast('未查询到角色信息，请检查角色ID后重试')
          return
        }
        if (roles.length === 1) {
          this.performBinding(roles[0], false)
          return
        }
        this.roleList = roles
        this.$nextTick(() => {
          if (requestId === this.roleQueryRequestId && this.roleList.length) {
            this.showRolePopup = true
          }
        })
      }).catch(error => {
        if (requestId !== this.roleQueryRequestId) return
        this.showRequestError(error, '查询超时，请点击重试', '角色信息查询失败，请稍后重试')
      }).finally(() => {
        if (requestId === this.roleQueryRequestId) {
          this.roleQueryLoading = false
          this.clearRoleQuerySlowTimer()
        }
      })
    },
    confirmSelectedRole () {
      if (!this.selectedRole || this.bindLoading) return
      this.performBinding(this.selectedRole)
    },
    performBinding (role, closePopup = true) {
      if (this.bindLoading) return
      const requestId = ++this.bindRequestId
      this.bindLoading = true
      const roleParams = this.isFromAPP ? role : {
        user_id: role.user_id,
        appkey: role.appkey,
        role_id: role.role_id,
      }
      qwBinding({
        id: this.query.id,
        gu: this.query.gu,
        external_userid: this.query.external_userid,
        scene_type: this.query.scene_type,
        ...roleParams,
      }).then(res => {
        if (requestId !== this.bindRequestId) return
        const { jump_url, role_id, user_id } = res.content
        this.jump_url = jump_url
        this.account = this.isFromAPP ? user_id : role_id
        if (closePopup) this.showRolePopup = false
        this.getBindInfo(false)
        this.inputValue = ''
        this.handleJump()
        console.log(res)
        this.buryReport("QY_WEIXIN_GENERAL_BIND", {
          qy_weixin_user: this.qy_weixin_user,
          type: this.isFromAPP ? 1 : 2,
          result: "绑定成功",
          user_id: this.account,
        });
      }).catch(error => {
        if (requestId !== this.bindRequestId) return
        this.showRequestError(error, '绑定超时，请点击重试', '绑定失败，请稍后重试')
        this.buryReport("QY_WEIXIN_GENERAL_BIND", {
          qy_weixin_user: this.qy_weixin_user,
          type: this.isFromAPP ? 1 : 2,
          result: "绑定失败"
        });
      }).finally(() => {
        if (requestId === this.bindRequestId) {
          this.bindLoading = false
        }
      })
    },
    clearRolePopupData () {
      this.roleList = []
      this.selectedRole = null
    },
    selectRole (role) {
      if (this.bindLoading) return
      this.selectedRole = role
    },
    clearRoleQuerySlowTimer () {
      if (this.roleQuerySlowTimer) {
        clearTimeout(this.roleQuerySlowTimer)
        this.roleQuerySlowTimer = null
      }
    },
    showRequestError (error, timeoutMessage, fallbackMessage) {
      const isTimeout = error && (error.code === 'ECONNABORTED' || `${error.message || ''}`.toLowerCase().includes('timeout'))
      if (isTimeout) {
        this.$toast(timeoutMessage)
        return
      }
      const businessMessage = error && (error.msg || error.response && error.response.data && (error.response.data.msg || error.response.data.message))
      this.$toast(businessMessage || fallbackMessage)
    },
    isSelectedRole (role) {
      return this.selectedRole && this.selectedRole.user_id === role.user_id &&
        this.selectedRole.appkey === role.appkey && this.selectedRole.role_id === role.role_id
    },
    // 延迟 2000ms 跳转活动页
    handleJump () {
      const delay = 2000
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: true,
        duration: delay + 300,
      });
      setTimeout(() => {
        this.onJump(false)
      }, delay)
    },
    onJump (manual = true) {
      if (manual) {
        this.buryReport("QY_WEIXIN_GENERAL_ACTIVITY", {
          qy_weixin_user: this.qy_weixin_user,
          type: this.isFromAPP ? 1 : 2,
          user_id: this.account,
        });
      }
      const u = this.jump_url
      if (u) {
        window.open((u.startsWith('http') ? '' : 'https://') + u, '_self')
      } else {
        manual && this.$toast('活动已结束')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  padding: 12px;
}

input {
  width: 100%;
  font-size: 12px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #e1e1e1;
  color: #5C5C5C;
  background-color: #f1f5ff;
  &:focus {
    border: 1px solid #565ADE;
  }
}

.oper_form {
  padding: 0 8px;
}

.down_img {
  height: 24px;
}

.card_wrap {
  border-radius: 6px;
  background-color: #fff;
  padding: 8px 12px;
  margin-bottom: 10px;
  .card_head {
    line-height: 24px;
    padding-bottom: 4px;
    border-bottom: 1px solid #e1e1e18f;
  }
  .card_main {
    padding: 20px 0;
  }
}

.bind_info {
  font-size: 18px;
  padding: 24px 12px;
  margin: 24px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0px 0px 6px 1px rgba(203,203,203,0.60); 
}

.role_popup {
  width: 88%;
  max-width: 420px;
  padding: 24px 20px 20px;
  color: #333;
  .role_popup_title {
    text-align: center;
    font-size: 20px;
    margin-bottom: 22px;
  }
  .role_popup_tip {
    font-size: 14px;
    margin-bottom: 12px;
  }
  .role_list {
    max-height: 48vh;
    overflow-y: auto;
  }
  .role_item {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 10px;
    margin-bottom: 12px;
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    font-size: 13px;
    line-height: 20px;
    background: #fff;
    &.active {
      border-color: #565ADE;
      background: #f1f5ff;
      box-shadow: 0 0 0 1px #565ADE inset;
    }
  }
  .role_popup_confirm {
    margin: 16px 0;
    font-size: 14px;
  }
  .role_confirm_btn {
    display: block;
    min-width: 108px;
    margin: 0 auto;
    border-radius: 6px;
  }
}
</style>
